// extracted by mini-css-extract-plugin
export default {"suggestionsForYou":"suggestionsForYou--nZUgZ","suggestionsSearches":"suggestionsSearches--qnv7f","suggestion":"suggestion--PrklS","suggestionImage":"suggestionImage--eciGr"};